export default __webpack_public_path__ + "static/Feedback_Default-37652f033a4413b3075e1af717138076.png";